import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Textarea } from 'ziphy-web-shared/basic/lib/forms/fields';
import { getTextareaProps } from './';
import DateTime from './dateTime/DateTime';
const TextareaDefault = ({ $element }) => {
    const { fieldProps } = useMemo(() => getTextareaProps($element), [$element.config]);
    const { config, renderType, field } = $element;
    if (Array.isArray(config.usedKeys)) {
        if (renderType === 'plain') {
            return field.value ? (_jsxs("span", { children: [config.usedKeys.map((key) => field.value[key] || ''), field.value.datetime ? _jsx(DateTime, { datetime: field.value.datetime }) : null] })) : null;
        }
        return (_jsx(_Fragment, { children: config.usedKeys.map((key) => (_jsx(Textarea, Object.assign({ field: Object.assign(Object.assign({}, field), { value: field.value[key], onChange: (value) => field.onChange(Object.assign(Object.assign({}, field.value), { [key]: value })) }) }, fieldProps), key))) }));
    }
    if (renderType === 'plain') {
        return field.value ? _jsx("span", { children: field.value }) : null;
    }
    return _jsx(Textarea, Object.assign({ field: field }, fieldProps));
};
export default observer(TextareaDefault);
